import {Store} from '../../../redux/Store'
import {AuthModel} from './_models'
import * as actions from '../../../redux/currentUser/CurrentUserAction'
import {signOut} from 'firebase/auth'
import {auth} from '../../../../firebaseConfig'

const setAuth = (auth: AuthModel, dispatch: any) => {
  try {
    dispatch(actions.setAuth(auth))
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = (dispatch: any) => {
  signOut(auth)
  dispatch(actions.removeAuth())
  dispatch(actions.removeCurrentUser())
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'

  axios.interceptors.request.use(
    async (config: {url: string; headers: {Authorization: string; businessKey: string}}) => {
      const store = Store.getState()
      const authState = store.globalStates.auth
      let apiToken = authState?.api_token

      if (auth.currentUser) {
        try {
          apiToken = await auth.currentUser.getIdToken()
          if (apiToken && apiToken !== authState?.api_token) {
            Store.dispatch(
              actions.setAuth({
                ...authState,
                api_token: apiToken,
              })
            )
            localStorage.setItem('idToken', apiToken)
          }
        } catch (error) {
          console.error('FIREBASE TOKEN REFRESH ERROR', error)
        }
      }

      if (apiToken) {
        config.headers.Authorization = `Bearer ${apiToken}`
        if (authState?.business_key !== undefined) {
          config.headers.businessKey = `${authState.business_key}`
        }
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      return response
    },
    async function (error: any) {
      console.log('error', error)
      const requestUrl: string = error.config?.url || ''
      const isPreAuthEndpoint = requestUrl.includes('/users/jit-migration-login')

      if (error.response?.status === 401 && !isPreAuthEndpoint) {
        window.location.replace('/logout')
      }
      else if (error.response?.status === 403) {
        window.location.replace('/forbidden')
      }
      else if (error.response?.status === 406) {
        window.location.replace('/not_exist')
      }
      else if (error.response?.status === 423) {
        window.location.replace('/no_subscription')
      }
      else return Promise.reject(error)   
    }
  )
}

export {setAuth, removeAuth}
